import React from 'react';
import {LinearProgress} from '@material-ui/core';

const SignupDialogContentLoading = () => (
    <LinearProgress style={{
            marginTop: '10px',
        }}/>
);

export default SignupDialogContentLoading;